import { valueConverter } from '../../util-functions/util-funtions'

const CheckLength = (value) => {
    if (value === null) {
        return value
    }
    else {
        if (value) {
            if (typeof value == 'number') {
                let a = value.toFixed(2)
                return a.toString().slice(0, 11)
            } else {
                return value.toString().slice(0, 11)
            }
        }
        else {
            return value
        }
    }
}

export const CheckLength_sep = (value,text) => {
    if (value === null) {
        return value
    }
    else {
        valueConverter(value,text)
        if (value.toString().length > 12) {
            if (typeof value == 'number') {
                let a = value.toFixed(0)
                return Number(a.toString().slice(0, 11)).toLocaleString()
            } else {
                return value.toString().slice(0, 11)
            }
        }
        else {
            return Number(value.toFixed(0)).toLocaleString()
        }
    }
}

export const valurFormaterFn_Total = (value) => {
    if (value === null) {
        return value
    }
    else {
        if (typeof value == 'object') {
            return Number(value).toFixed(0)
        }
    }
}


export default CheckLength;

